/* eslint-disable no-bitwise */
import * as React from "react";
import * as Survey from "survey-react";

import { PersonRequest } from "@plinknz/tah-website-elements";

import { BenefitForm } from "./benefit-form";
import { CustomerFormQuestionTypes } from "./customer-form-types";
import { createSurveyConfig } from "../../../service/forms/tuna-wananga-survey-config";
import { transformTunaWanangaData } from "../../../utility/form-transforms/transform-tuna-wananga-data";

export const TunaWanangaForm = () => {
  const transformData = (
    survey: Survey.ReactSurveyModel,
    member: PersonRequest
  ) => {
    return transformTunaWanangaData(survey, member);
  };

  return (
    <BenefitForm
      createSurveyConfig={createSurveyConfig}
      transformData={transformData}
      questionTypes={
        CustomerFormQuestionTypes.AddressFinder |
        CustomerFormQuestionTypes.DatePicker
      }
    />
  );
};
